import React from "react";
import { useTranslation } from "react-i18next";
import Auth from "@rill/auth";
import { useRillContext } from "../rill/RillReact/share/base";
import getErrorMessage from "../utils/getErrorMessage";

function View(props) {
  const { t } = useTranslation("auth");
  const { locals } = useRillContext();

  const { query } = locals;
  const { redirect } = query;
  return (
    <div id="login-wrapper">
      <img
        className="logo"
        src="/img/msb-logo-white.svg"
        alt={t("login.logoAlt")}
      />

      <form method="POST" data-noreset>
        {redirect && <input type="hidden" name="redirect" value={redirect} />}

        <div className="frame narrow">
          <div className="columns">
            <div className="column" data-col="1/1">
              <label htmlFor="email" className="label">
                {t("login.emailLabel")} <span className="required-input">*</span>
              </label>
              <input
                className="text-input"
                type="email"
                name="email"
                placeholder={t("login.emailPlaceholder")}
                required
              />
            </div>

            <div className="column" data-col="1/1">
              <label htmlFor="password" className="label">
                {t("login.passwordLabel")} <span className="required-input">*</span>
              </label>
              <input
                className="text-input"
                type="password"
                name="password"
                placeholder={t("login.passwordPlaceholder")}
                required
              />
            </div>

            <div className="column" data-col="1/2">
              <label className="checkbox-input">
                <input type="checkbox" name="remember" />
                <span className="checkbox" />
                <span className="text">{t("login.rememberMe")}</span>
              </label>
            </div>

            <div
              className="column"
              data-col="1/2"
              style={{ textAlign: "right" }}
            >
              <a href="/forgot">{t("login.forgotPassword")}</a>
            </div>

            <div className="column" data-col="1/1">
              <button className="button-input full" type="submit">
                {t("login.submit")}
              </button>
            </div>
          </div>
        </div>
        <div className="login-signup">
          {t("login.coachSignup")} <a href="/signup-coach"> {t("login.signUpHere")}</a>
        </div>
        <div className="login-signup">
          <a href="/login-new-onboarding">{t("login.newOnboarding")}</a>
        </div>
      </form>
    </div>
  );
}

const Login = (app) => {
  app
    .get(
      "/login-old",
      Auth.isLoggedOut({ redirect: "dashboard" }),
      ({ res }) => (res.body = <View />)
    )
    .post("/login", async ({ req: { body }, res, api, login, flash }) => {
      const { redirect = "/coaching-portal" } = body;
      delete body.redirect;
      const { token, userId, error } = await (
        await api("login", {
          method: "POST",
          body,
        })
      ).json();

      if (error) {
        flash("error", getErrorMessage(error));
        return res.backDontScroll();
      }

      const sessionOptions = { refresh: true };
      if (!body.remember) {
        sessionOptions.ttl = "2 weeks";
      }
      await login({ _id: userId, token }, sessionOptions);

      if (redirect === "back") res.backDontScroll();
      else res.redirect(redirect);
    })
    .get("/logout", ({ req, res, logout, session }) => {
      if (typeof window !== "undefined" && window.localStorage) {
        localStorage.removeItem("exercisesToCopy");
        localStorage.removeItem("originalAthleteLibraryToCopy");
      }
      logout();
      session.clear();
      res.redirect("/login" + req.search);
    });
};

export default Login;
